<script>
import MagLinkOmni from './MagLinkOmni.vue';

export default {
  components: {
    MagLinkOmni,
  },
  data: () => ({
    items: [
      {
        icon: 'mdi-phone',
        link: 'tel:+74956020020',
        label: '+7 (495) 6-020-020',
        target: '',
      },
      {
        icon: 'mdi-at',
        link: 'mailto:info@mag.travel',
        label: 'E-mail',
        target: '',
      },
      {
        icon: 'mdi-facebook-messenger',
        link: 'https://m.me/1159429430805490',
        label: 'Facebook messenger',
        target: '_blank',
      },
      {
        icon: 'mdi-vk',
        link: 'https://vk.me/mag.travel',
        label: 'Вконтакте',
        target: '_blank',
      },
      {
        icon: 'V',
        link: 'viber://pa?chatURI=magtravel',
        label: 'Viber',
        target: '',
      },
    ],
  }),
};
</script>
<template>
  <v-list>
    <v-subheader>ОБРАТИТЬСЯ В ТЕХПОДДЕРЖКУ</v-subheader>
    <MagLinkOmni/>
    <v-list-item
      v-for="(item, idx) in items"
      :key="idx"
      :target="item.target"
      :href="item.link"
    >
      <v-list-item-action v-if="item.icon">
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-title>{{ item.label }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>
<style lang="scss">

</style>
